import {runtimeEnv} from 'shared/lib/runtimeEnv';

export const buildFileUrl = (path?: string | null): string | null => {
    if (!path) {
        return null;
    }

    if (/^https?:\/\//i.test(path)) {
        return path;
    }

    const host = runtimeEnv('REACT_APP_BASE_HOST');

    return `${host.replace(/\/$/, '')}${path.startsWith('/') ? path : `/${path}`}`;
};
